import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import Component from '../core/component';
import { isUndefined } from 'lodash';
/*----------------------------------------------------*/
// Constants & variables

/*----------------------------------------------------*/

var INSTANCE;
var FIELD_GROUP = '.form__field';
var defaults = {
  name: 'fields',
  $$: {
    text: 'input.input-field, textarea.input-field',
    select: 'select[data-select]'
  }
};
var properties = {
  fields: new Set()
};
/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Fields = /*#__PURE__*/function (_Component) {
  _inherits(Fields, _Component);

  var _super = _createSuper(Fields);

  function Fields() {
    var _this2;

    var _this;

    var wrapper = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Object.create(null);

    _classCallCheck(this, Fields);

    // singleton
    if (INSTANCE) return _possibleConstructorReturn(_this, INSTANCE); // wrapper

    var $wrapper = Component.isElement(wrapper);

    if (typeof $wrapper === 'undefined' || !$wrapper) {
      throw new Error('Passed wrapper is not a valid element');
    } // options


    var opts = _objectSpread(_objectSpread({}, defaults), options);

    _this = _super.call(this, opts); // properties

    Object.assign(_assertThisInitialized(_this), Component.cloneDeep(properties));
    _this.$wrapper = $wrapper; // eslint-disable-next-line prefer-rest-params

    (_this2 = _this).init.apply(_this2, arguments);

    INSTANCE = _assertThisInitialized(_this);
    return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
  }

  _createClass(Fields, [{
    key: "init",
    value: function init() {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _get(_getPrototypeOf(Fields.prototype), "init", this)).call.apply(_get2, [this].concat(args));

      this.$select(this.$wrapper);
      this.attach();
      return this;
    } // Methods
    // --------------------------------------------------

  }, {
    key: "attach",
    value: function attach() {
      var _this3 = this;

      // text fields
      this.$wrapper.find(this.$$.text).each(function (i, elm) {
        if (!_this3.fields.has(elm)) {
          _this3.attachTextField(elm);
        }
      }); // select fields

      this.$wrapper.find(this.$$.select).each(function (i, elm) {
        if (!_this3.fields.has(elm)) {
          _this3.attachSelect(elm);
        }
      });
    }
  }, {
    key: "update",
    value: function update() {
      var _this4 = this;

      // drop removed elements
      var remove = [];
      this.fields.forEach(function (elm) {
        if (!_this4.$wrapper[0].contains(elm)) {
          remove.push(elm);
        }
      });
      remove.forEach(function (elm) {
        $d(elm).remove();

        _this4.fields.delete(elm);
      }); // attach new elements

      this.attach();
    } // Text fields
    // --------------------------------------------------

  }, {
    key: "attachTextField",
    value: function attachTextField(elm) {
      var $elm = $d(elm);
      var $elmGroup = Fields.getGroup(elm);
      var classes = $elm.attr('class').split(' ');
      var klass = null;
      classes.forEach(function (cls) {
        if (cls.indexOf('input-') > -1) {
          klass = cls.replace('input-', "".concat(FIELD_GROUP.replace('.', ''), "--"));
        }
      });

      if (klass) {
        $elmGroup.addClass(klass);
      }

      function onInputChange() {
        var $this = $d(this);
        var $group = Fields.getGroup(this);

        if ($this.val().trim() === '') {
          $group.removeClass('input--filled');
        } else {
          $group.addClass('input--filled');
        }
      }

      function onInputFocus() {
        var $group = Fields.getGroup(this);
        $group.addClass('input--focused');
      }

      function onInputBlur() {
        var $this = $d(this);
        var $group = Fields.getGroup(this);
        $group.removeClass('input--focused');

        if ($this.val().trim() === '') {
          $group.removeClass('input--filled');
        }
      }

      if ($elm.val().trim() !== '') {
        $elmGroup.addClass('input--filled');
      }

      $elm.on({
        'change.fields': onInputChange,
        'focus.fields': onInputFocus,
        'blur.fields': onInputBlur,
        'keyup.fields': onInputChange
      }); // chrome fix

      if (!isUndefined(window.chrome)) {
        setTimeout(function () {
          if ($elm.attr('type') === 'password') {
            $elm.trigger('change');
            var autofill = $elm.parent().find('input:-webkit-autofill');

            if (autofill.length) {
              $elmGroup.addClass('input--filled');
            }
          }
        }, 250);
      }

      this.fields.add(elm);
    } // Select fields
    // --------------------------------------------------

  }, {
    key: "attachSelect",
    value: function attachSelect(elm) {
      var $elm = $d(elm);
      if ($elm.data('styled')) return;
      var $elmGroup = Fields.getGroup(elm);
      var $wrapper = $d('<div class="custom-select" />');
      var $placeholder = $d('<span class="select__placeholder" />');
      var $button = $d('<span class="select__button" />'); // share classes

      var attr = $elm.data('select');
      var classes = $elm.attr('class');
      var name = $elm.attr('name');
      var disabled = $elm.is(':disabled');

      if (classes) {
        $wrapper.attr('class', "".concat(classes, " ").concat($wrapper.attr('class')));
      }

      if (attr) {
        $wrapper.addClass("select--".concat(attr));
      }

      if (name) {
        $wrapper.addClass("select--".concat(name));
      }

      if (disabled) {
        $wrapper.addClass('select--disabled');
      } // update group if needed


      if ($elmGroup[0] === $elm[0]) {
        $elmGroup = $wrapper;
      }

      $wrapper.append($placeholder, $button).insertAfter($elm); // cash-dom append & prepend have some strange issues

      $wrapper[0].appendChild($elm[0]);
      $elm.attr('class', '').addClass('select__select');

      function onSelectChange() {
        var $group = Fields.getGroup(this);
        var $selected = $d(this.options[this.selectedIndex]);
        var disable = $selected.prop('disabled');
        var value = $selected.attr('value');
        $placeholder.html($selected.html());

        if (disable === true) {
          $group.addClass('input--disabled');
        } else {
          $group.removeClass('input--disabled');
        }

        if (typeof value !== 'undefined' && value.trim() !== '' && value !== 'null') {
          $group.addClass('input--filled');
        } else {
          $group.removeClass('input--filled');
        }
      }

      $elm.data('styled', true);
      elm.fieldsGroup = $elmGroup;
      onSelectChange.apply(elm);
      $elm.on('change.fields', onSelectChange);
      $elm.on('fields:update', onSelectChange);
      this.fields.add(elm);
    } // Static methods
    // --------------------------------------------------

  }], [{
    key: "getGroup",
    value: function getGroup(elm) {
      var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FIELD_GROUP;
      var $elm = $d(elm);
      var $group = elm.fieldsGroup || null;
      if ($group) return $group;
      var elmGroup = $elm.data('fields-group');
      $group = $elm;

      if (elmGroup && elmGroup.trim() !== '') {
        var $parent = $elm.closest(".".concat(elmGroup));
        if ($parent.length) $group = $parent;
      } else {
        var _$parent = $elm.closest(group);

        if (_$parent.length) $group = _$parent;
      }

      elm.fieldsGroup = $group;
      return $group;
    }
  }, {
    key: "update",
    value: function update() {
      if (INSTANCE) {
        INSTANCE.update();
        return INSTANCE;
      }

      return false;
    }
  }]);

  return Fields;
}(Component);

export { Fields as default };

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}